import { Container, Navbar, Nav, Button } from "react-bootstrap";
import { Link, useLocation } from 'react-router-dom';
import { BoxArrowRight, CameraVideoFill, ListUl } from "react-bootstrap-icons";
import { root } from "../../utils/Constants";

interface Props {
  isLogged: boolean;
  onLogout: () => void;
}

export default function MyNavbar({ isLogged, onLogout }: Props) {

  const location = useLocation();
  const isListActive = location.pathname === root + 'list' || location.pathname.startsWith(root + 'webinar/');

  return (
    <Navbar expand="md" className="admin-navbar">
      <Container>
        <Navbar.Brand as={Link} to={`${root}list`}>
          <span className="brand-mark"><CameraVideoFill /></span>
          Webinar Admin
        </Navbar.Brand>
        { isLogged && <>
          <Navbar.Toggle aria-controls="admin-navbar-nav" />
          <Navbar.Collapse id="admin-navbar-nav">
            <Nav className="me-auto"></Nav>
            <Button variant="light" size="sm" onClick={() => onLogout()}>
              <BoxArrowRight /> Logout
            </Button>
          </Navbar.Collapse>
        </> }
      </Container>
    </Navbar>
  )
}
